import { forwardRef, Select, SelectProps } from '@chakra-ui/react'
// import { companies } from '../utils/companies'
import { useInsurers } from '../hooks'

interface CompaniesSelectProps extends SelectProps { }

export const CompaniesSelect = forwardRef((props: CompaniesSelectProps, ref) => {
  const { data: dataInsurers } = useInsurers(null, true)
  const companies = dataInsurers?.data ?? []


  return (
    <Select {...props} ref={ref}>
      <option value="">
        Všechny pojišťovny
      </option>
      {companies &&
        companies.length > 0 &&
        companies.map((company) => {
          return (
            <option key={company.id} value={company.id}>
              {company.name}
            </option>
          )
        })}
    </Select>
  )
})
